import axios from "axios";
import qs from 'qs';
import * as ENV from "../env";
import tokenService from '../services/token';
import { CampaignStats } from "./reportCustomer/reportCustomerApi";
import { PermissionMenu } from "./rank/issuedCardApi";



export interface ResponseSuccessType<T> {
  status?: boolean;
  data: T;
  message?: string;
  type?: "nem" | "em"
}


export interface ResponseSuccessNonData {
  status?: boolean;
  message?: string;
  type?: "nem" | "em";
  totalCustomerTarget?: number;
  avgAge?: number;
}


export interface ResponsePostSuccess {
  success: boolean;
  message: string;
}

export interface ResponsePostSuccessData<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface ResponseSuccessStores<T> {
  status?: boolean;
  data: T;
  message?: string;
  presentMoney?: string
}
export interface ResponseSuccessActive<T> {
  status?: boolean;
  data: T;
  message?: string;
  errorCode?: number
}

export interface ResponseSuccess<T> {
  status?: boolean;
  data: T;
  message?: string;
}

export interface ResponseSuccessReport<T> {
  status?: boolean;
  data: T;
  brands: T;
  message?: string;
}

export interface ResponseSuccessTotal<T> {
  status?: boolean;
  data: T;
  message?: string;
  total: number | 0
  sqlTotal?: string
}
export interface ResponseSuccessTotalV3<T> {
  status?: boolean;
  data: T;
  message?: string;
  total: number | 0
  email?: CampaignStats
  zns?: CampaignStats
  sms?: CampaignStats

}


export interface ResponseSuccessTotalV2<T> {
  status?: boolean;
  data: T;
  message?: string;
  total: number | 0
  sqlTotal?: string
  nextLastCardId?: number
  nextLastId?: number
  permissionMenu?: PermissionMenu
}

export interface ResponseSuccessTotalReportVoucher<T> {
  status?: number,
  data: T
  total: number | 0
  pageNumber?: number
  limit?: number
  summary?: {
    totalIssued: number,
    totalRedeemed: number,
    rateRedeemed: number,
  }
  message?: string;
}

export interface ResponseError {
  status?: number,
  title: string,
  errors: {
    [key: string]: string[]
  }
}

const axiosClient = axios.create({
  baseURL: ENV.API_URL,
  headers: {
    'content-type': 'multipart/form-data',
  },
  paramsSerializer: {
    serialize: params => {
      return qs.stringify(params, { arrayFormat: 'repeat', allowDots: true });
    }
  }
});

axiosClient.interceptors.request.use(async (config) => {
  const token = tokenService.getToken();
  if (token)
    config.headers.Authorization = 'Bearer ' + token;
  return config;
}, (error) => {
  return Promise.reject(error);
});

axiosClient.interceptors.response.use((response) => {
  if (response && response.data) {
    return response.data;
  }
  return response;
}, (error) => {
  if (error.code === 'ERR_CONNECTION_TIMED_OUT') {
    // Lỗi do timeout
    return Promise.resolve({
      status: false,
      data: null,
      message: 'Không có phản hồi từ hệ thống',
    } as ResponseSuccess<null>);
  } else
    if (error.response && error.response.data && error.response.data.error &&
      (error.response.data.session === false || error.response.data.session === "false")) {
      // alert("Đã xảy ra sự cố, sẽ tự động đăng xuất.");
      window.location.href = "/";
    } else if (error?.response && error.response?.data && error.response.data.error && error.response.data.error.message) {
      return error?.response?.data
    } else if (error.response && error.response.status === 500) {
      return error?.response?.data;
    } else if (error?.response && error?.response?.status === 401) {
      return Promise.reject(error);
    } else {
      return error?.response?.data;
    }
  Promise.reject(error);
});

export default axiosClient;
